import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DeleteEntityModule } from 'src/app/shared/delete-entity/delete-entity.module';
import { CompanyPageDisassociateVendorsModalComponent } from './company-page-disassociate-vendors-modal.component';

@NgModule({
  declarations: [CompanyPageDisassociateVendorsModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    DeleteEntityModule
  ],
  exports: [CompanyPageDisassociateVendorsModalComponent],
  entryComponents: [CompanyPageDisassociateVendorsModalComponent]
})
export class CompanyPageDisassociateVendorsModalModule { }
